import { Box } from "@mui/material";
import React from "react";

import BackButton from "../../components/backButton";
import { NextButton } from "../../components";

const CoverageButtonWrapper = ({
  displayBackButton,
  displayNextButton,
  backButtonName,
  nextButtonName,
  handleBackAction,
  handleNextAction,
  isDisabled,
  isBackDisabled,
}) => {
  const showBothButtons = displayBackButton && displayNextButton;
  return (
    <Box
      mt={3}
      mb={3}
      display="flex"
      justifyContent={
        showBothButtons
          ? "space-between"
          : displayBackButton
            ? "flex-start"
            : "flex-end"
      }
    >
      {displayBackButton && (
        <BackButton
          name={backButtonName}
          handleBack={handleBackAction}
          isDisabled={isBackDisabled}
        />
      )}
      {displayNextButton && (
        <NextButton
          name={nextButtonName}
          handleNext={handleNextAction}
          isDisabled={isDisabled}
        />
      )}
    </Box>
  );
};

export default CoverageButtonWrapper;
